import DocumentHeader from '@/components/DocumentHeader';
import { OneColumn } from '@/components/Layout';
import loadable from '@loadable/component';
import { Navigation } from '@/components/Navigation';
import track from 'react-tracking';
import { Plans } from './components/Plans/Plans';
import { Reviews } from './components/Reviews/Reviews';
import { FeaturedOn } from './components/FeaturedOn/FeaturedOn';
import { CompareFeatures } from './components/CompareFeatures/CompareFeatures';
import { MainContainer, Header, NavContainer, HeaderContainer } from './styled';

/**react-query */
import { useQuery } from '@tanstack/react-query';

import {
  getPlansContent,
  getReviewsCms,
  getFeaturedOnCms,
  getDefaultPlansCms,
  getDefaultHomeCms,
} from './query';

import { Row } from '@simplywallst/ui-core';
import { useFlag } from '@/features/unleash';

const ZendeskWidget = loadable(() => import('./components/ZendeskWidget'), {
  resolveComponent: (c) => c.ZendeskWidget,
});

const Footer = loadable(() => import('@/components/Footer'));

const OurPlans = () => {
  const { data: plansFeatureData = getDefaultPlansCms() } = useQuery({
    queryKey: ['plansContent'],
    queryFn: getPlansContent,
    staleTime: Infinity,
  });

  const { data: reviewsCms = getDefaultHomeCms() } = useQuery({
    queryKey: ['reviewsCms'],
    queryFn: getReviewsCms,
    staleTime: Infinity,
  });
  const { data: featuredOnCms = getDefaultHomeCms() } = useQuery({
    queryKey: ['featuredOnCms'],
    queryFn: getFeaturedOnCms,
    staleTime: Infinity,
  });

  const { enabled: enableZendeskWidget } = useFlag({ name: 'zendesk-widget' });

  return (
    <>
      <MainContainer>
        <HeaderContainer justifyContent="center">
          <OneColumn>
            <DocumentHeader
              allowCrawlers
              title="Pricing Plans"
            ></DocumentHeader>
            <NavContainer>
              <Navigation />
            </NavContainer>
            <Header>
              <h2>Pick the plan that’s right for your investing needs</h2>
            </Header>
            <Plans />
          </OneColumn>
        </HeaderContainer>
        <CompareFeatures
          title={plansFeatureData.title}
          markdownContent={plansFeatureData.markdownContent}
        />
        <Row justifyContent="center">
          <OneColumn>
            <FeaturedOn
              gallery={featuredOnCms.gallery}
              title={featuredOnCms.title}
            />
          </OneColumn>
        </Row>
        <Reviews markdownContent={reviewsCms.markdownContent} />
      </MainContainer>
      <OneColumn>
        <Footer />
      </OneColumn>
      {enableZendeskWidget && <ZendeskWidget />}
    </>
  );
};

export default track(
  {
    type: 'track',
    subject: 'page',
    action: 'landed',
    page: 'plans',
  },
  { dispatchOnMount: true }
)(OurPlans) as typeof OurPlans;
